// @generated da scripts/i18n-sr-cyrl.mjs — NON EDITARE A MANO.
// i18n area 'common' — locale sr-Cyrl-RS: TRASLITTERAZIONE MECCANICA
// di common.sr-Latn-RS.ts (srpska latinica). Ogni modifica va fatta
// sulla locale sr-Latn-RS e poi rigenerata con: node scripts/i18n-sr-cyrl.mjs
// Sidecar anti-stantie: ../meta/common.sr-Cyrl-RS.meta.json.
import type { enUS } from './common'

export const srCyrlRS: typeof enUS = {
  nav: {
    home: 'Home',
    vms: 'Виртуелне машине',
    templates: 'Шаблони',
    importVms: 'Увези VM',
    containers: 'Контејнери',
    containersApps: 'Апликације',
    containersPods: 'Подови',
    containersCt: 'CT',
    multiscsi: 'TVStor MultiSCSI',
    containersOciImages: 'OCI слике',
    containersOciRegistries: 'OCI registryji',
    containersCtTemplates: 'CT шаблони',
    networkServices: 'Мрежни сервиси',
    firewall: 'Firewall',
    checkpoints: 'Checkpointi',
    backup: 'Резервне копије',
    monitoring: 'Надгледање',
    cluster: 'Кластер',
    clusterSettings: 'Глобална подешавања',
    clusterNodes: 'Чворови',
    clusterDevices: 'USB и PCIe ресурси',
    clusterFederation: 'Федерација',
    network: 'Мрежа',
    overlayNetworks: 'Overlay мреже',
    fabric: 'Fabric',
    ipam: 'IPAM',
    storage: 'Storage',
    data: 'Подаци',
    storages: 'Storage',
    hci: 'Хиперконвергенција',
    ceph: 'Ceph',
    system: 'Систем',
    tasks: 'Задаци',
    events: 'Догађаји',
    audit: 'Аудит',
    diagnostics: 'Дијагностика',
    notifications: 'Обавештења',
    proximity: 'TVirt Proximity',
    users: 'Корисници и групе',
    groups: 'Групе',
    mfa: 'MFA',
    realms: 'Реалмови и SSO',
    rbac: 'Улоге и дозволе',
    credentials: 'Акредитиви',
    scopes: 'Scope',
    tags: 'Тагови',
    explorer: 'Истражи',
    licensing: 'Лиценца',
    information: 'Информације'
  },
  mode: {
    light: 'Светла',
    dark: 'Тамна',
    system: 'Системска',
    tooltip: 'Тема'
  },
  language: {
    tooltip: 'Језик'
  },
  langRegion: {
    europe: 'Европа',
    northAmerica: 'Северна Америка',
    southAmerica: 'Јужна Америка',
    asia: 'Азија'
  },
  notFound: {
    title: 'Страница није пронађена',
    body: 'Ова адреса не одговара ниједној TVirt страници — можда се померила са неким ажурирањем, или је link застарео.',
    backHome: 'Назад на Home'
  },
  scopeBrowser: {
    title: 'Scope',
    all: 'Цео кластер',
    noChildren: 'Овде нема под-scopeova',
    recursive: 'Укључи потомке',
    collapse: 'Скупи панел scopeova',
    openPicker: 'Истражи scopeove',
    up: 'Један ниво навише',
    countTooltip: '{direct} у овом scopeu · {total} са потомцима'
  },
  search: {
    tooltip: 'Претражи (⌘K)',
    placeholder: 'Претражи VM-ове, мреже, storage…',
    empty: 'Нема резултата',

    // Round command palette (#221, ratifica 2026-08-06): intestazioni dei
    // gruppi, i tipi fuori dal censimento explorer, il vocabolario tasti e i
    // verbi del gruppo Azioni.
    groups: {
      recent: 'Недавно',
      shortcuts: 'Пречице',
      actions: 'Акције',
      goTo: 'Иди на'
    },
    kind: {
      catalog: 'Каталог',
      scope: 'Scope',
      node: 'Чвор'
    },
    footer: {
      navigate: 'кретање',
      open: 'отвори',
      close: 'затвара'
    },
    actions: {
      createVm: 'Креирај VM…',
      uploadIso: 'Отпреми ISO…',
      clusterSettings: 'Подешавања кластера',
      consoleOf: 'Иди на конзолу за {name}'
    }
  },
  stub: {
    containersSummary: 'Апликације и системски контејнери (CT), са својим OCI сликама, registryjima и шаблонима — управљани уз ваше VM-ове.',
    sectionSummary_vms: 'Виртуелне машине и њихови шаблони — животни циклус, снимци, миграција и конзоле.',
    sectionSummary_storages: 'Storage на којима живе дискови, слике и метаподаци VM-ова.',
    sectionSummary_catalogs: 'Дом датотечних артефаката кластера: ISO слике, CT и VM шаблони и OCI архиве, организовани у каталоге.',
    sectionSummary_overlay: 'VXLAN overlay мреже између чворова кластера.',
    sectionSummary_fabric: 'Инвентар физичке мреже — switchevi, портови, LAGG-ови и логичке мреже.',
    sectionSummary_ipam: 'Адресирање изведено из fabric и overlay мрежа: ко држи сваку адресу.',
    sectionSummary_services: 'DHCP и DNS сервери изведени из мрежног регистра.',
    sectionSummary_ceph: 'Управљани Ceph кластери на TVirt чворовима.',
    sectionSummary_hci: 'Хиперконвергентне storage технологије на TVirt чворовима.',
    sectionSummary_cluster: 'Чворови, чланство и подешавања на нивоу кластера.',
    containers: 'Системски контејнери су на roadmapu — ова секција ће их удомити.',
    containersApps: 'Контејнеризоване апликације су на roadmapu — ова област ће их удомити.',
    containersPods: 'Подови групишу контејнере који деле мрежу и волумене — instance су апликације.',
    containersCt: 'Системски контејнери (CT) су на roadmapu — ова област ће их удомити.',
    multiscsi: 'TVStor MultiSCSI је на roadmapu — ова област ће га удомити.',
    clusterFederation: 'Федерација између TVirt кластера је на roadmapu — ова област ће је удомити.',
    containersOciImages: 'OCI слике су на roadmapu — ова област ће их удомити.',
    containersOciRegistries: 'OCI registryji су на roadmapu — ова област ће их удомити.',
    containersCtTemplates: 'CT шаблони су на roadmapu — ова област ће их удомити.',
    importVms: 'Овде ће стићи ESXi и Proxmox импортери: конверзија guestova и масовна миграција у TVirt.',
    backup: 'Интегрисане резервне копије стижу са 6.2: дедупликовани content-addressed репозиторијуми, CBT инкрементали, прозори непроменљивости и repo-to-repo репликација.',
    monitoring: 'Дасхбоарди надметања за ресурсе на нивоу целог кластера (cpu.ready, PSI притисак, уграђени алерти) су на путу — данас исте метрике живе у детаљима сваке VM.'
  },
  home: {
    welcome: 'Пријављени сте као: {name}',
    subtitle: 'Ево вашег TVirt кластера на први поглед.',
    loadError: 'Преглед није могуће учитати — да ли је TVirt backend доступан?',
    health: {
      ok: 'Све је у реду',
      warning: 'Потребна пажња',
      critical: 'Критични проблеми'
    },
    reason: {
      'node-down': '{subject} је угашен',
      'node-stale': '{subject} се не јавља већ неко време',
      'node-maintenance': '{subject} у одржавању',
      'tasks-failed': {
        one: '{n} неуспешан задатак у последња 24h',
        few: '{n} неуспешна задатка у последња 24h',
        other: '{n} неуспешних задатака у последња 24h'
      },
      'storage-degraded': 'storage {subject} деградиран',
      'storage-error': 'storage {subject} у стању грешке',
      'ceph-warning': 'Ceph {subject}: HEALTH_WARN',
      'ceph-error': 'Ceph {subject}: HEALTH_ERR',
      'store-unreachable': 'store кластера недоступан',
      'license-absent': 'нема лиценце — нови VM-ови не могу да се покрену',
      'license-expired': 'лиценца истекла — нови VM-ови не могу да се покрену',
      'license-exceeded': 'лимит лиценце прекорачен — нови VM-ови не могу да се покрену',
      'failover-reserve-eroded': 'failover резерва скоро потрошена',
      'failover-reserve-exhausted': 'failover резерва исцрпљена — нови VM-ови не могу да се покрену',

      'oci-cache-nearly-full': 'OCI кеш скоро пун на {subject} — digesti се избацују ручно',
      'oci-cache-full': 'OCI кеш пун на {subject} — ниједан pull неће успети док се digesti не избаце',
      'config-replica-empty': 'реплика конфигурације на {subject} је PRAZNA — чвор нема конфигурацију кластера док репликација не успе',
      'config-replica-stalled': 'репликација конфигурације на {subject} стоји — локална копија заостаје за конфигурацијом кластера'
    },
    staleChip: 'Подаци нису ажурни',
    staleAsOf: 'последња реплика {time}',
    zone: {
      nodes: 'Чворови',
      failoverReserve: 'Failover резерва',
      capacity: 'Капацитет',
      workload: 'Радно оптерећење',
      protection: 'Заштита',
      activity: 'Недавна активност'
    },

    // La zona riserva di failover (admission control N+1, task #133b).
    reserve: {
      state: {
        ok: 'Резерва нетакнута',
        eroded: 'Резерва скоро потрошена',
        exhausted: 'Резерва исцрпљена',
        unknown: 'Резерва непозната'
      },
      tolerate: {
        one: 'толерише губитак {n} чвора',
        few: 'толерише губитак {n} чвора',
        other: 'толерише губитак {n} чворова'
      },
      usedOf: '{used} / {allowed} GiB у употреби',
      keepFree: '{n} GiB се држи слободно за failover',
      expendable: 'од чега се {n} може жртвовати у раду',
      headroom: 'може се покренути још {n} GiB',
      short: 'резерви недостаје {n} GiB — нови VM-ови не могу да се покрену',

      // Pagine enormi per taglia (ratifica 2026-08-04) — forma «etichetta:
      // {n}» apposta: nessuna lingua deve declinare dopo un numero variabile.
      hp: {
        usedOf: 'Странице од {size} — у употреби: {used} / {allowed}',
        keepFree: 'држе се слободне за failover: {keep}',
        headroom: 'још се могу покренути: {n}',
        short: 'недостаје резерви: {n} — нови VM-ови са огромним страницама не могу да се покрену'
      },
      worstCase: 'најгори случај: {nodes}',
      unavailable: '{node}: {reason}',
      unknown: 'Ниједан чвор још није пријавио меморију — резерва се не може израчунати и ниједно покретање се не одбија.',
      reason: {
        attestedDown: 'атестиран као угашен',
        maintenance: 'у одржавању',
        unreachable: 'недоступан',
        capacityUnknown: 'меморија није пријављена'
      }
    },
    node: {
      cpu: '{n} CPU',
      cpuTopology: '{cores} core / {threads} thread',
      memUsedOf: '{used} / {total} GiB',
      activeVms: {
        one: '{n} активан VM',
        few: '{n} активна VM-а',
        other: '{n} активних VM-ова'
      },
      activeVmsUnknown: 'број активних VM-ова непознат',
      lastSeen: 'виђен {time}',
      neverSeen: 'никад виђен',
      down: 'Угашен',
      maintenance: 'Одржавање',
      stale: 'Недоступан'
    },
    capacity: {
      usedOf: '{used} / {total} GiB',
      provisioned: '{n} GiB провизионисано',
      reserve: 'резерва {n} GiB',
      unobserved: 'капацитет још није посматран',
      empty: 'Још нема storagea'
    },
    workload: {
      vms: 'Виртуелне машине',
      apps: 'Апликације',
      services: 'Мрежни сервиси',
      empty: 'Још ништа',
      phasesUnknown: 'расподела по фазама није доступна'
    },
    protection: {
      none: 'Ниједно одредиште бекапа није конфигурисано — заштитите своју конфигурацију.',
      configure: 'Конфигуриши checkpointe',
      noRuns: 'Ниједан checkpoint још није креиран.',
      last: 'Последњи checkpoint',
      onTarget: 'на {target}',
      viewAll: 'Checkpointi'
    },
    activity: {
      empty: 'Нема недавне активности',
      failed24: {
        one: '{n} неуспешан у 24h',
        few: '{n} неуспешна у 24h',
        other: '{n} неуспешних у 24h'
      },
      viewAll: 'Види све задатке'
    }
  },
  notes: {
    title: 'Белешке',
    tabEdit: 'Измени',
    tabPreview: 'Преглед',
    placeholder: 'Слободне белешке оператера — Markdown се рендерује у прегледу',
    empty: 'Нема белешки',
    tooLarge: 'Белешке премашују лимит од 64 KiB',
    saveError: 'Чување белешки није успело'
  },
  common: {

    // Round «errori onesti» (2026-08-03): una risposta 200 che questo client
    // non sa leggere NON è una rete giù — accusare il backend manda
    // l'operatore a guardare un servizio che funziona (bug hunt #157, U1).
    contractError: 'Одговор backenda садржи вредност коју овај интерфејс не познаје: {field}={value} — ажурирајте webui на верзију backenda.',
    contractErrorItems: 'Објекти ове листе које овај интерфејс не уме да прочита ({field}={value}) нису приказани — укупно: {count}.',
    staleHint: 'Store није доступан — ово је реплика конфигурације овог чвора; стање флоте је непознато.',
    staleStateAge: 'стање од {time}',
    staleStateNever: 'стање никад није примљено из store-a: видите само опажања овог чвора',
    staleStateTooltip: 'Store кластера није доступан: опажено стање (фаза, чвор, агент) долази из реплике стања овог чвора и потиче из последњег успешног читања из store-a — може бити застарело.',
    noPermission: 'Немате дозволу за ову радњу',

    // Un budget di attesa scaduto NON è un esito (Luca 2026-08-06): il
    // cronometro del client misura la pazienza del client, non lo stato del
    // server — l'avviso dice «ancora in corso», mai «non riuscita».
    actionStillRunning: 'Акција је још у току: исход још није познат',
    staleWrite: 'Неко други је изменио овај објекат док сте га уређивали — ништа није уписано. Поново учитајте и поновите измену на свежем стању.',
    staleReload: 'Поново учитај',
    preview: 'Преглед',
    previewTitle: 'Преглед резултата',
    previewNothingWritten: 'Симулирано на серверу — ништа није уписано.',
    previewChanged: 'Истакнуте су вредности које би се промениле.'
  },
  context: {
    copySelection: 'Копирај изабрани текст'
  },
  crud: {
    create: 'Креирај',
    viewDetails: 'Прикажи детаље',
    viewOrEdit: 'Види или измени',
    selected: 'изабрано',
    viewUsingVms: 'Види VM-ове који користе ресурс',
    clearSelection: 'Поништи избор',
    deleteSelected: 'Обриши изабрано',
    bulkConfirmBody: {
      one: 'Обрисати изабрану ставку ({count})? Ако је заштићена, биће пријављена и задржана.',
      few: 'Обрисати изабране ставке ({count})? Заштићене ће бити пријављене и задржане.',
      other: 'Обрисати изабране ставке ({count})? Заштићене ће бити пријављене и задржане.'
    },
    bulkDeleted: 'обрисано',
    bulkRefused: 'одбијено',
    fieldId: 'ID',
    createdAt: 'Креирано',
    updatedAt: 'Ажурирано',
    immutableField: 'Фиксирано при креирању — contract не дозвољава измену',
    immutableScope: 'Scope се додељује при креирању; неки ресурси се премештају наменском радњом',
    observedField: 'Посматрано стање — пријављује га платформа, не може се мењати'
  }
}
